/* eslint-disable react/destructuring-assignment */

import React, { useEffect, useState, useRef, useCallback } from 'react';
import { GoogleMap, useLoadScript, Marker } from '@react-google-maps/api';
import usePlacesAutocomplete, { getGeocode, getLatLng } from 'use-places-autocomplete';
import useOnclickOutside from 'react-cool-onclickoutside';
import { TextInput } from '../../../../canvasComponents/index';
// Note : Removed library @reach/combobox, reason: Not compatiable with Reactv18
import './Map.scss';
import Geocode from 'react-geocode';
import VisibilitySensor from 'react-visibility-sensor-v2';
import { useIntl } from 'react-intl';
import { GoogleMapsKey } from '../../../../config';
import { PossiblePlacesModal } from './PossiblePlacesModal/PossiblePlacesModal';
import getAddressObject from './GoogleAddressParser';
// set Google Maps Geocoding API for purposes of quota management. Its optional but recommended.
Geocode.setApiKey(GoogleMapsKey);
// set response language. Defaults to english.
Geocode.setLanguage('en');
const libraries = ['places'];
const language = 'en';
const mapContainerStyle = {
  height: '100%',
  width: '100%',
};
const options = {
  disableDefaultUI: true,
  zoomControl: true,
  minZoom: 4,
};
export default function Map(props) {
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: GoogleMapsKey,
    libraries,
    language,
  });
  const [selectedPlace, setSelectedPlace] = useState({});
  const [possiblePlaces, setPossiblePlaces] = useState({});
  const [mapCenter, setMapCenter] = useState({
    lat: 49.2827291,
    lng: -123.1207375,
  });
  const [showMarker, setShowMarker] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const intl = useIntl();

  useEffect(() => {
    window.addEventListener('storage', (e) => {
      if (e.key === 'policyAddress') {
        if (props.value === null
        && props.value === undefined) {
          setPolicyAddress();
        }
      }
    }, false);
  }, []);

  useEffect(() => {
    if (
      props.value !== null
      && props.value !== undefined
      && Object.prototype.hasOwnProperty.call(props.value, 'coords')
    ) {
      setSelectedPlace({
        address: {
          street: props.value.street,
          streetName: props.value.streetName,
          city: props.value.city,
          provinceState: props.value.provinceState,
          postalCode: props.value.postalCode,
          country: props.value.country,
        },
        value: props.value.value,
        coords: props.value.coords,
        url: props.value.url,
      });
      setMapCenter(props.value.coords);
      setShowMarker(true);
    }
  }, [props.value]);

  const formattedAddress = (address) => {
    let fAddress = '';
    if (address.street !== '') {
      fAddress = fAddress.concat(`${address.street} `);
    }
    if (address.streetName !== '') {
      fAddress = fAddress.concat(`${address.streetName} `);
    }
    if (address.city !== '') {
      fAddress = fAddress.concat(`${address.city} `);
    }

    if (address.country === 'CA') {
      if (address.province !== '') {
        fAddress = fAddress.concat(`${address.province} `);
      }
      if (address.postalCode !== '') {
        fAddress = fAddress.concat(`${address.postalCode} `);
      }
    } else {
      if (address.state !== '') {
        fAddress = fAddress.concat(`${address.state} `);
      }
      if (address.zipCode !== '') {
        fAddress = fAddress.concat(`${address.zipCode} `);
      }
    }

    if (address.country !== '') {
      fAddress = fAddress.concat(address.country);
    }
    return fAddress;
  };
  const showCurrentPosition = (position) => {
    const { latitude, longitude } = position.coords;
    setMapCenter({ lat: latitude, lng: longitude });
  };
  const setPolicyAddress = async () => {
    const address = window.sessionStorage.getItem('policyAddress');
    if (address && address !== '') {
      try {
        const results = await getGeocode({ address });
        const { lat, lng } = await getLatLng(results[0]);
        setMapCenter({ lat, lng });
      } catch (error) {
        setMapCenter({ lat: mapCenter.lat, lng: mapCenter.lng });
      }
    } else {
      setMapCenter({ lat: mapCenter.lat, lng: mapCenter.lng });
    }
  };
  const onMapClick = useCallback((e) => {
    const lat = e.latLng.lat();
    const lng = e.latLng.lng();

    Geocode.fromLatLng(lat, lng).then(
      (response) => {
        let streetAddressFound = response.results.filter((p) => {
          let found = false;
          if (p.types && p.types.length) {
            const typesFound = p.types.some((type) => (type === 'street_address'));
            if (typesFound) {
              found = true;
            }
          }
          return found;
        });
        let routeFound = response.results.filter((p) => {
          let found = false;
          if (p.types && p.types.length) {
            const typesFound = p.types.some((type) => (type === 'route'));
            if (typesFound) {
              found = true;
            }
          }
          return found;
        });
        let intersectionFound = response.results.filter((p) => {
          let found = false;
          if (p.types && p.types.length) {
            const typesFound = p.types.some((type) => (type === 'intersection '));
            if (typesFound) {
              found = true;
            }
          }
          return found;
        });
        if ((streetAddressFound?.length && routeFound?.length) || (streetAddressFound?.length && intersectionFound?.length) || (routeFound?.length && intersectionFound?.length)) {
          streetAddressFound = streetAddressFound.map((address) => ({
            value: formattedAddress(getAddressObject(address.address_components)),
            address: getAddressObject(address.address_components),
            coords: { lat, lng },
            url: `http://maps.google.com/maps?q=${lat},${lng}`,
          }));
          routeFound = routeFound.map((address) => ({
            value: formattedAddress(getAddressObject(address.address_components)),
            address: getAddressObject(address.address_components),
            coords: { lat, lng },
            url: `http://maps.google.com/maps?q=${lat},${lng}`,
          }));
          intersectionFound = intersectionFound.map((address) => ({
            value: formattedAddress(getAddressObject(address.address_components)),
            address: getAddressObject(address.address_components),
            coords: { lat, lng },
            url: `http://maps.google.com/maps?q=${lat},${lng}`,
          }));
          let possiblePlacesArray = [];
          if (streetAddressFound[0]?.value === routeFound[0]?.value) {
            possiblePlacesArray.push(streetAddressFound[0], intersectionFound[0]);
          } else if (routeFound[0]?.value === intersectionFound[0]?.value || streetAddressFound[0]?.value === intersectionFound[0]?.value) {
            possiblePlacesArray.push(streetAddressFound[0], routeFound[0]);
          } else {
            possiblePlacesArray.push(streetAddressFound[0], routeFound[0], intersectionFound[0]);
          }
          possiblePlacesArray = possiblePlacesArray.filter(Boolean);
          if (possiblePlacesArray.length > 1) {
            setPossiblePlaces(possiblePlacesArray);
            setShowModal(true);
          } else {
            setFinalAddress(possiblePlacesArray[0], 'map');
          }
        } else if (streetAddressFound?.length) {
          setFinalAddress({
            value: formattedAddress(getAddressObject(streetAddressFound[0].address_components)),
            address: getAddressObject(streetAddressFound[0].address_components),
            coords: { lat, lng },
            url: `http://maps.google.com/maps?q=${lat},${lng}`,
          }, 'map');
        } else if (routeFound?.length) {
          setFinalAddress({
            value: formattedAddress(getAddressObject(routeFound[0].address_components)),
            address: getAddressObject(routeFound[0].address_components),
            coords: { lat, lng },
            url: `http://maps.google.com/maps?q=${lat},${lng}`,
          }, 'map');
        } else if (intersectionFound?.length) {
          setFinalAddress({
            value: formattedAddress(getAddressObject(intersectionFound[0].address_components)),
            address: getAddressObject(intersectionFound[0].address_components),
            coords: { lat, lng },
            url: `http://maps.google.com/maps?q=${lat},${lng}`,
          }, 'map');
        } else {
          setFinalAddress({
            value: formattedAddress(getAddressObject(response.results[0].address_components)),
            address: getAddressObject(response.results[0].address_components),
            coords: { lat, lng },
            url: `http://maps.google.com/maps?q=${lat},${lng}`,
          }, 'map');
        }
      },
      (error) => {
        props.pindropErrorHandling();
        // eslint-disable-next-line
        console.error('onMapClick', error);
      },
    );
  }, []);

  const setFinalAddress = (selectedplace, type) => {
    setShowModal(false);
    if (type === 'map') {
      setSelectedPlace(selectedplace);
      setMapCenter({ lat: selectedplace.coords.lat, lng: selectedplace.coords.lng });
      props.setSubmitAddressMap(selectedplace);
    } else if (type === 'modal') {
      props.setSubmitAddressModal(selectedplace);
    }
  };

  const mapRef = useRef();

  const onMapLoad = useCallback((map) => {
    mapRef.current = map;
  }, []);

  const panTo = useCallback(({ lat, lng }) => {
    mapRef.current.panTo({ lat, lng });
    mapRef.current.setZoom(15);
  }, []);

  // eslint-disable-next-line react/no-unstable-nested-components
  function Search() {
    const {
      ready,
      value,
      suggestions: { status, data },
      setValue,
      clearSuggestions,
    } = usePlacesAutocomplete();
    const ref = useOnclickOutside(() => {
      // When user clicks outside of the component, we can dismiss
      // the searched suggestions by calling this method
      clearSuggestions();
    });
    const handleInput = (currentValue) => {
      setValue(currentValue);
    };
    const handleSelect = async (suggestion) => {
      // When user selects a place, we can replace the keyword without request data from API
      // by setting the second parameter to "false"
      setValue(suggestion, false);
      clearSuggestions();

      try {
        const results = await getGeocode({ address: suggestion });
        const fetchedAddress = getAddressObject(results[0].address_components);
        const { lat, lng } = await getLatLng(results[0]);
        setFinalAddress({
          value: formattedAddress(fetchedAddress),
          address: fetchedAddress,
          coords: { lat, lng },
          url: `http://maps.google.com/maps?q=${lat},${lng}`,
        }, 'map');
        panTo({ lat, lng });
      } catch (error) {
        props.pindropErrorHandling();
        // eslint-disable-next-line
        console.log('Search Error: ', error);
      }
    };

    const renderSuggestions = () => {
      const suggestions = data.map((suggestion) => ({
        value: suggestion.description,
        label: <span>{suggestion.description}</span>,
      }));
      return suggestions;
    };

    return (
      <div ref={ref} className="search">
        <TextInput
          searchable
          searchResults={status === 'OK' ? renderSuggestions() : []}
          emptySearchResultsMessage="No results"
          minLengthForSearchResults={1}
          placeholder={intl.formatMessage({ id: 'Search for address or intersection', defaultValue: 'Search for address or intersection' })}
          primary
          disabled={!ready}
          onSelect={(suggestion) => handleSelect(suggestion)}
          onChange={(currentValue) => handleInput(currentValue)}
          value={value}
        />
      </div>
    );
  }
  if (loadError) return props.pindropErrorHandling();
  if (!isLoaded) return 'Loading...';
  return (
    <VisibilitySensor
      partialVisibility
      onChange={(isVisible) => {
        if (isVisible && (props.value === null || typeof props.value === 'undefined')) {
          if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
              showCurrentPosition,
              setPolicyAddress,
            );
          } else {
            setPolicyAddress();
          }
        } else if (
          isVisible
          && props.value !== null
          && typeof props.value === 'undefined'
          && !Object.prototype.hasOwnProperty.call(props.value, 'coords')
        ) {
          if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
              showCurrentPosition,
              setPolicyAddress,
            );
          } else {
            setPolicyAddress();
          }
        }
      }}
    >
      <GoogleMap
        id="map"
        mapContainerStyle={mapContainerStyle}
        zoom={Object.keys(selectedPlace).length ? 15 : 9}
        initialCenter={mapCenter}
        center={mapCenter}
        options={options}
        onClick={onMapClick}
        onLoad={onMapLoad}
      >
        <Search />
        <PossiblePlacesModal
          showModal={showModal}
          setShowModal={setShowModal}
          possiblePlaces={possiblePlaces}
          selectedPlace={selectedPlace}
          setFinalAddress={setFinalAddress}
          formattedAddress={formattedAddress}
          localParams={props.localParams}
        />
        {showMarker && (
        <Marker
          key={`${mapCenter.lat}-${mapCenter.lng}`}
          position={{
            lat: mapCenter.lat,
            lng: mapCenter.lng,
          }}
        />
        )}
      </GoogleMap>
    </VisibilitySensor>
  );
}
